export default __webpack_public_path__ + "static/media/thep.7a701ca0.png";